/* Cocoon Galaxy — immersive layer: starfield, cursor glow, scroll reveal, 3D card tilt */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  /* ---------- Starfield background ---------- */
  function initStarfield() {
    var canvas = document.getElementById('cocoon-stars-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var stars = [];
    var shootingStars = [];
    var w, h, dpr;

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      buildStars();
    }

    function buildStars() {
      var count = Math.min(170, Math.floor((w * h) / 9000));
      stars = [];
      for (var i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.4 + 0.3,
          baseAlpha: Math.random() * 0.5 + 0.3,
          twinkleSpeed: Math.random() * 0.02 + 0.005,
          twinklePhase: Math.random() * Math.PI * 2,
          driftX: (Math.random() - 0.5) * 0.02,
          driftY: (Math.random() - 0.5) * 0.02
        });
      }
    }

    function maybeSpawnShootingStar() {
      if (Math.random() < 0.002 && shootingStars.length < 2) {
        shootingStars.push({
          x: Math.random() * w * 0.6,
          y: Math.random() * h * 0.3,
          vx: 6 + Math.random() * 4,
          vy: 3 + Math.random() * 2,
          life: 0,
          maxLife: 40 + Math.random() * 20
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.twinklePhase += s.twinkleSpeed;
        s.x += s.driftX;
        s.y += s.driftY;
        if (s.x < 0) s.x = w;
        if (s.x > w) s.x = 0;
        if (s.y < 0) s.y = h;
        if (s.y > h) s.y = 0;
        var alpha = s.baseAlpha + Math.sin(s.twinklePhase) * 0.25;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(245,242,255,' + Math.max(0, Math.min(1, alpha)) + ')';
        ctx.fill();
      }

      maybeSpawnShootingStar();
      for (var j = shootingStars.length - 1; j >= 0; j--) {
        var sh = shootingStars[j];
        sh.x += sh.vx;
        sh.y += sh.vy;
        sh.life++;
        var t = 1 - sh.life / sh.maxLife;
        if (t <= 0) {
          shootingStars.splice(j, 1);
          continue;
        }
        var grad = ctx.createLinearGradient(sh.x, sh.y, sh.x - sh.vx * 6, sh.y - sh.vy * 6);
        grad.addColorStop(0, 'rgba(232,183,93,' + t + ')');
        grad.addColorStop(1, 'rgba(232,183,93,0)');
        ctx.strokeStyle = grad;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(sh.x, sh.y);
        ctx.lineTo(sh.x - sh.vx * 6, sh.y - sh.vy * 6);
        ctx.stroke();
      }

      requestAnimationFrame(draw);
    }

    window.addEventListener('resize', resize, { passive: true });
    resize();
    requestAnimationFrame(draw);
  }

  /* ---------- Cursor glow ---------- */
  function initCursorGlow() {
    var glow = document.getElementById('cocoon-cursor-glow');
    if (!glow) return;
    var isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isFine) return;

    var targetX = window.innerWidth / 2;
    var targetY = window.innerHeight / 2;
    var currentX = targetX;
    var currentY = targetY;

    window.addEventListener(
      'mousemove',
      function (e) {
        targetX = e.clientX;
        targetY = e.clientY;
        glow.classList.add('is-active');
      },
      { passive: true }
    );

    document.addEventListener('mouseleave', function () {
      glow.classList.remove('is-active');
    });

    function animate() {
      currentX += (targetX - currentX) * 0.12;
      currentY += (targetY - currentY) * 0.12;
      glow.style.transform = 'translate(' + currentX + 'px,' + currentY + 'px) translate(-50%,-50%)';
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }

  /* ---------- Scroll reveal for each theme section ---------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    sections.forEach(function (el, idx) {
      if (idx === 0) return; // keep hero visible immediately
      el.classList.add('cocoon-reveal');
      observer.observe(el);
    });
  }

  /* ---------- Subtle 3D tilt on card-like elements ---------- */
  function initCardTilt() {
    var isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isFine) return;

    var candidates = document.querySelectorAll('[class*="card"]');
    candidates.forEach(function (card) {
      if (card.dataset.cocoonTilt) return;
      var rect = card.getBoundingClientRect();
      if (rect.width < 120 || rect.width > 560 || rect.height < 120 || rect.height > 560) return;

      card.dataset.cocoonTilt = '1';
      card.classList.add('cocoon-tilt');
      card.style.transformStyle = 'preserve-3d';

      card.addEventListener(
        'mousemove',
        function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          var rotateY = (px - 0.5) * 10;
          var rotateX = (0.5 - py) * 10;
          card.style.transform = 'perspective(900px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
          card.classList.add('is-tilting');
        },
        { passive: true }
      );

      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
        card.classList.remove('is-tilting');
      });
    });
  }

  function init() {
    initStarfield();
    initCursorGlow();
    initScrollReveal();
    initCardTilt();
    // product cards can render after initial load (quick add, section re-render)
    setTimeout(initCardTilt, 1200);
    setTimeout(initCardTilt, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
